import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en.json';
import rg4js from 'raygun4js';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

import { NoSsr } from '@mui/base';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { APP_VER, BASE_PATH } from './core/config';
import { router } from './core/config/routes';
import { isRaygunEnabled } from './core/errors/errors.lib';
import { mainTheme } from './core/theme_v5/mainTheme';
import UpdatesListenerWrapper from './main/elevators/websockets/updates-listener-wrapper/UpdatesListenerWrapper';
import store from './store';
import CookiePopup from './ui/components/cookie-popup/CookiePopup';
import FlashMessage from './ui/components/flash-messages/flash-message/FlashMessage';
import TermsOverlay from './ui/components/terms-overlay/TermsOverlay';
import UpdateOverlay from './ui/components/update-overlay/UpdateOverlay';

if (isRaygunEnabled()) {
  rg4js('apiKey', isRaygunEnabled() as string);
  rg4js('enableCrashReporting', true);
  rg4js('setVersion', APP_VER);
}

TimeAgo.addDefaultLocale(en);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // default: true
      retry: 2,
      staleTime: 10 * 60,
    },
  },
});

if (!window.location.pathname.includes(BASE_PATH)) {
  window.location.replace('/app/home');
}

function App() {
  return (
    <NoSsr>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
          <UpdatesListenerWrapper />
          <ThemeProvider theme={mainTheme}>
            <CssBaseline />
            <RouterProvider router={router} future={{ v7_startTransition: true }}></RouterProvider>
            <UpdateOverlay />
            <TermsOverlay />
            <CookiePopup />
            <FlashMessage />
          </ThemeProvider>
        </QueryClientProvider>
      </Provider>
    </NoSsr>
  );
}

export default App;
